<template>
  <div class="login-page">
    <div class="login-box">
      <div class="login-header">
        <img src="@/assets/logo.png" class="login-logo" alt="logo" @error="logoError = true" v-if="!logoError" />
        <h1 class="login-title">妙笔</h1>
        <p class="login-subtitle">AI 短篇小说创作平台</p>
      </div>

      <el-form
        ref="loginForm"
        :model="form"
        :rules="rules"
        class="login-form"
        @keyup.enter.native="handleLogin"
      >
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入用户名"
            prefix-icon="el-icon-user"
            clearable
          />
        </el-form-item>

        <el-form-item prop="password">
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            prefix-icon="el-icon-lock"
            show-password
          />
        </el-form-item>

        <el-form-item v-if="captchaEnabled" prop="code">
          <div class="captcha-row">
            <el-input
              v-model="form.code"
              placeholder="请输入验证码"
              prefix-icon="el-icon-key"
              class="captcha-input"
            />
            <img
              :src="captchaImg"
              class="captcha-img"
              title="点击刷新验证码"
              @click="loadCaptcha"
            />
          </div>
        </el-form-item>

        <el-button
          type="primary"
          class="login-btn"
          :loading="loading"
          @click="handleLogin"
        >
          {{ loading ? '登录中...' : '登 录' }}
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getCaptcha, login } from '@/api/auth';

export default {
  name: 'Login',
  data() {
    return {
      logoError: false,
      loading: false,
      captchaEnabled: false,
      captchaImg: '',
      form: {
        username: '',
        password: '',
        code: '',
        uuid: ''
      },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      }
    };
  },
  created() {
    this.loadCaptcha();
  },
  methods: {
    async loadCaptcha() {
      try {
        const res = await getCaptcha();
        this.captchaEnabled = res.captchaEnabled;
        if (res.captchaEnabled) {
          this.captchaImg = 'data:image/jpg;base64,' + res.img;
          this.form.uuid = res.uuid;
          this.form.code = '';
        }
      } catch (e) {
        // 获取验证码失败不阻断登录页渲染
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate(async valid => {
        if (!valid) return;
        this.loading = true;
        try {
          const res = await login(
            this.form.username,
            this.form.password,
            this.form.code,
            this.form.uuid
          );
          localStorage.setItem('MIAOBI_TOKEN', res.token);
          const redirect = this.$route.query.redirect || '/';
          this.$router.replace(redirect);
        } catch (e) {
          // 错误已由 request.js 拦截器统一提示，刷新验证码
          this.loadCaptcha();
        } finally {
          this.loading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('~@/assets/login_bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-box {
  width: 400px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 12px;
  padding: 48px 40px 40px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.login-header {
  text-align: center;
  margin-bottom: 36px;
}

.login-logo {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin-bottom: 12px;
}

.login-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 6px;
}

.login-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.captcha-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.captcha-input {
  flex: 1;
}

.captcha-img {
  width: 120px;
  height: 40px;
  border-radius: 0;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  flex-shrink: 0;
  object-fit: cover;
}

.captcha-img:hover {
  opacity: 0.85;
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
  margin-top: 8px;
}

.login-btn:hover {
  opacity: 0.9;
}
</style>
